import axios from 'axios';

const getTamaraCheckoutUrlApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Payment/tamara/preparePayment?order_id=${
      paramsFilter?.id ?? ''
    }`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getTamaraCheckoutUrlApi;
